<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<h1 class="act" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Praise for the Writing of Gemma Files</h1>
<p> </p><p> </p>
<p class="noindent">“Gemma Files has one of the great dark imaginations in fiction―visionary, transgressive, and totally original.” —Jeff VanderMeer</p>
<p class="noindent">“She is, simply put, one of the most powerful and unique voices in weird fiction today.” —Paul Tremblay</p>
<p class="center"><i><b>Experimental Film</b></i></p>
<p class="noindent">“<i>Experimental Film</i> is sensational. When we speak of the best in contemporary horror and weird fiction, we must speak of Gemma Files.” —Laird Barron</p>
<p class="center"><i><b>A Book of Tongues</b></i></p>
<p class="noindent">“Boundary-busting horror-fantasy … This promising debut fully delivers both sizzling passions and dark chills.” —<i>Publishers Weekly</i></p>
<p class="noindent">“Truly one-of-a-kind: violent, carnal and creepy.” —Chris Alexander, <i>Fangoria</i></p>
<p class="center"><i><b>We Will All Go Down Together</b></i></p>
<p class="noindent">“What makes <i>We Will All Go Down Together</i> so riveting isn’t its ideas or imagery, as richly atmospheric and detailed as they are. It’s the author’s voice. Colorful, powerful, and charismatic, her characters are rendered in bold strokes and poignant nuances.” —NPR.com</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?bb80c9cc